import { parse, stringify, extract } from 'query-string';

import { merge } from './reducerUtils';
import { isNullOrUndefined } from './generalUtils';

/**
 * Get the query params from a url
 * @param  {String} url Url
 * @return {Object}     Query param hash
 */
export function getQueryParams(url) {
    return parse(extract(url));
}

/**
 * Generate a new url using a given url and a
 * query params hash. The new url will consist of
 * the given url with a query string of the given query params
 * appended to it.
 * @param  {String} url        Old product tile url
 * @param  {Object} queryParams Query param hash
 * @return {String}            New product tile url
 */
export function getQueryParamsUrl(url = '', queryParams = {}) {
    const oldQueryParams = getQueryParams(url);
    const newQueryParams = _.omitBy(queryParams, isNullOrUndefined);
    const targetQueryParams = merge(oldQueryParams, newQueryParams);
    const newQueryString = stringify(targetQueryParams);
    const location = url.replace(/\?.*/, '');

    return `${location}?${newQueryString}`;
}

/**
 * Strip the hash from the current URL and push new state to history.
 * If no hash is present, no state is pushed.
 * PWA modals skip this functionality
 *
 * @return {Void}
 */
export function removeHash(modalInstance) {
    const isNotPWAModal = _.get(modalInstance, 'feature', '') !== 'pwa';

    if (window.location.hash && isNotPWAModal) {
        history.pushState(
            "",
            document.title,
            window.location.pathname + window.location.search
        );
    }
}

